import { render, staticRenderFns } from "./DatesPicker.vue?vue&type=template&id=2510e37a&scoped=true"
import script from "./DatesPicker.vue?vue&type=script&lang=js"
export * from "./DatesPicker.vue?vue&type=script&lang=js"
import style0 from "./DatesPicker.vue?vue&type=style&index=0&id=2510e37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2510e37a",
  null
  
)

export default component.exports